import { baseClient } from './baseRequest';

export enum PlanStatus {
  Active = 'Active',
  Unlisted = 'Unlisted',
  Deleted = 'Deleted',
}

export type Plan = {
  id: string;
  title?: string;
  price: number;
  upfrontAmount: number;
  revSharePercentage: number;
  isAdvanced: boolean;
  explanation?: string;
  status: PlanStatus;
  createdAt: Date;
  updatedAt: Date;
};

const planApiClient = {
  getActivePlans: (): Promise<Plan[]> =>
    baseClient.get<Plan[]>({ url: '/plans' }),

  getPlanById: (planId: string): Promise<Plan> =>
    baseClient.get<Plan>({ url: `/plans/${planId}` }),
};

export default planApiClient;
